export const styles = {
  pageWrap: {
    padding: "20px",
    backgroundColor: "#fafafa",
    minHeight: "100vh",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  titleArea: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  mainTitle: {
    fontSize: "20px",
    fontWeight: "600",
    color: "#2C2C2C",
  },
  subTitle: {
    fontSize: "14px",
    color: "#7e7e7e",
    marginTop: "5px",
    marginLeft: "30px",
  },
  adminViewBadge: {
    backgroundColor: "#f3e8ff",
    color: "#8b5cf6",
    padding: "4px 12px",
    borderRadius: "16px",
    fontSize: "12px",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    gap: "5px",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: "10px",
    border: "1px solid #Eaeaea",
    padding: "20px",
    marginBottom: "20px",
  },
  profileHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    flexWrap: "wrap",
    gap: "15px",
  },
  employeeInfo: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    minWidth: "200px",
  },
  empName: {
    fontSize: "16px",
    fontWeight: "bold",
  },
  empId: {
    fontSize: "12px",
    color: "#7e7e7e",
  },
  infoCol: {
    display: "flex",
    flexDirection: "column",
  },
  infoLabel: {
    fontSize: "12px",
    color: "#aaaaaa",
  },
  infoValue: {
    fontSize: "14px",
    fontWeight: "500",
  },
  infoValueBlue: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "#3b82f6",
  },
  sectionTitle: {
    fontSize: "16px",
    fontWeight: "600",
    marginBottom: "15px",
  },
  changeItemBox: {
    border: "1px solid #Eaeaea",
    borderRadius: "10px",
    padding: "20px",
    marginBottom: "15px",
  },
  comparisonRow: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
    marginBottom: "15px",
    flexWrap: "wrap",
  },
  fieldInfo: {
    flex: 1,
  },
  fieldName: {
    fontSize: "14px",
    fontWeight: "bold",
    marginBottom: "5px",
  },
  valueText: {
    fontSize: "14px",
  },
  valueTextGreen: {
    fontSize: "14px",
    color: "#1fc157",
    fontWeight: "500",
  },
  valueOldStrikethrough: {
    fontSize: "14px",
    color: "#6b7280",
    textDecoration: "line-through",
  },
  valueLabel: {
    fontSize: "12px",
    color: "#a0a0a0",
    marginTop: "4px",
  },
  arrowIcon: {
    color: "#d1d5db",
  },
  requestDate: {
    fontSize: "12px",
    color: "#a0a0a0",
    textAlign: "right",
  },
  actionArea: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flexWrap: "wrap",
    justifyContent: "flex-end",
  },
  rejectBtn: {
    border: "1px solid #ef4444",
    color: "#ef4444",
    textTransform: "none",
    padding: "6px 20px",
    borderRadius: "6px",
    "&:hover": {
      backgroundColor: "#fef2f2",
    },
  },
  approveBtnOutline: {
    border: "1px solid #1fc157",
    color: "#1fc157",
    textTransform: "none",
    padding: "6px 20px",
    borderRadius: "6px",
    "&:hover": {
      backgroundColor: "#f0fdf4",
    },
  },
  approveBtnSolid: {
    backgroundColor: "#1fc157",
    color: "#fff",
    textTransform: "none",
    padding: "8px 24px",
    borderRadius: "6px",
    "&:hover": {
      backgroundColor: "#16a34a",
    },
  },
  commentsArea: {
    marginTop: "10px",
  },
  commentLabel: {
    fontSize: "12px",
    color: "#6b7280",
    marginBottom: "8px",
  },
  commentInput: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: "6px",
      backgroundColor: "#fafafa",
    },
  },
  charCount: {
    fontSize: "12px",
    color: "#9ca3af",
    textAlign: "right",
    marginTop: "5px",
  },
  footerActions: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "15px",
    marginTop: "20px",
    flexWrap: "wrap",
  },
  summaryPanel: {
    height: "100%",
    backgroundColor: "#fff",
    border: "1px solid #Eaeaea",
    borderRadius: "10px",
    padding: "20px",
  },
  summaryHeaderRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
    flexWrap: "wrap",
    gap: "10px",
  },
  summaryTitle: {
    fontSize: "16px",
    fontWeight: "bold",
  },
  pendingTag: {
    backgroundColor: "#fef3c7",
    color: "#d97706",
    fontSize: "12px",
    padding: "2px 8px",
    borderRadius: "4px",
    fontWeight: "500",
  },
  summaryPendingCount: {
    color: "#8b5cf6",
    backgroundColor: "#f3e8ff",
    fontSize: "12px",
    padding: "4px 8px",
    borderRadius: "6px",
    fontWeight: "bold",
  },
  summaryItem: {
    marginBottom: "20px",
    borderBottom: "1px solid #f3f4f6",
    paddingBottom: "15px",
  },
  summaryFieldName: {
    fontSize: "13px",
    fontWeight: "bold",
    color: "#374151",
    marginBottom: "8px",
  },
  summaryValuesRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "10px",
    flexWrap: "wrap",
  },
  summaryValOld: {
    fontSize: "12px",
    color: "#9ca3af",
    textDecoration: "line-through",
  },
  summaryValNew: {
    fontSize: "12px",
    color: "#1fc157",
    fontWeight: "500",
  },
};
